import { apiRequest } from ".";

export const getUsersAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `admin/users`,
    queryParams: data,
  });
};

export const getUserMealsUsageStatsAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `user-meals/usage-stats`,
    queryParams: data,
  });
};
